import {IoLocationOutline} from 'react-icons/io5'
import {BsBriefcase, BsStarFill} from 'react-icons/bs'
import './index.css'

const SimilarJobs = props => {
  const {similarJobs} = props
  const {
    companyLogoUrl,
    title,
    jobDescription,
    employmentType,
    location,
    rating,
  } = similarJobs

  return (
    <li className="similar-job-card">
      <div className="similar-header">
        <img
          src={companyLogoUrl}
          alt="similar job company logo"
          className="similar-company-logo"
        />

        <div>
          <h4 className="similar-title">{title}</h4>

          <div className="similar-rating">
            <BsStarFill className="star-icon" />
            <p>{rating}</p>
          </div>
        </div>
      </div>

      <h4 className="similar-sec-title">Description</h4>
      <p className="similar-desc">{jobDescription}</p>

      <div className="similar-info-row">
        <div className="similar-info-item">
          <IoLocationOutline className="similar-info-icon" />
          <p>{location}</p>
        </div>

        <div className="similar-info-item">
          <BsBriefcase className="similar-info-icon" />
          <p>{employmentType}</p>
        </div>
      </div>
    </li>
  )
}

export default SimilarJobs
